export function createSvgImageUrl(icon) {
    return `data:image/svg+xml;base64,${btoa(icon)}`;
}
